import {
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';

import {
  AQUAO_ADDRESS_MAX,
  AQUAO_CITY_MAX,
  AQUAO_DESTINATAIRE_MAX,
  AQUAO_EMAIL_MAX,
  AQUAO_OFFREUR_MAX,
  AQUAO_TEXT_UX_MAX
} from '../../../../core/model/aquao-field-limits.model';
import { GiftCartItem } from '../../../../core/model/cart/cart-item.model';
import {
  DestinataireCombinedMaxLength,
  EmailValidator
} from '../shared/validators/validators';
import { GiftFormGroup } from './gift-form.model';

/**
 * Crée un formulaire cadeau avec tous les validateurs statiques partagés.
 * @param gift Données cadeau utilisées pour initialiser les contrôles.
 * @param enforceAquaoLength Si faux, omet les plafonds de longueur (checkout : le backend clippe,
 *   pour ne pas bloquer silencieusement le paiement d'un panier déjà rempli).
 * @returns FormGroup cadeau prêt à recevoir les validateurs dynamiques liés au format et au destinataire.
 */
export function createGiftFormGroup(gift: GiftCartItem, enforceAquaoLength = true): GiftFormGroup {
  const maxLength = (max: number): ValidatorFn[] => enforceAquaoLength ? [ Validators.maxLength(max) ] : [];
  return new FormGroup({
    sentToMe: new FormControl(gift.sentToMe, { nonNullable: true, validators: [ Validators.required ] }),
    format: new FormControl(gift.format, { nonNullable: true, validators: [ Validators.required ] }),
    from: new FormControl(gift.from, {
      nonNullable: true,
      validators: [ Validators.required, ...maxLength(AQUAO_OFFREUR_MAX) ]
    }),
    firstName: new FormControl(gift.firstName, {
      nonNullable: true,
      validators: maxLength(AQUAO_DESTINATAIRE_MAX)
    }),
    lastName: new FormControl(gift.lastName, {
      nonNullable: true,
      validators: maxLength(AQUAO_DESTINATAIRE_MAX)
    }),
    email: new FormControl(gift.email, {
      nonNullable: true,
      validators: [ EmailValidator, ...maxLength(AQUAO_EMAIL_MAX) ]
    }),
    address: new FormControl(gift.address, {
      nonNullable: true,
      validators: maxLength(AQUAO_ADDRESS_MAX)
    }),
    zip: new FormControl(
      (gift.zip ?? '').replace(/[^0-9]/g, '').slice(0, 5),
      {
        nonNullable: true,
        // FrenchZipValidator est posé dynamiquement en mode postal (pas au checkout)
        validators: maxLength(5)
      }
    ),
    city: new FormControl(gift.city, {
      nonNullable: true,
      validators: maxLength(AQUAO_CITY_MAX)
    }),
    message: new FormControl(gift.message, {
      nonNullable: true,
      validators: maxLength(AQUAO_TEXT_UX_MAX)
    }),
    shipDate: new FormControl(gift.shipDate, { nonNullable: true })
  }, { validators: enforceAquaoLength ? [ DestinataireCombinedMaxLength() ] : [] });
}
